import { render } from "./FooterLocations.vue?vue&type=template&id=6f885199&scoped=true"
import script from "./FooterLocations.vue?vue&type=script&lang=js"
export * from "./FooterLocations.vue?vue&type=script&lang=js"

import "./FooterLocations.vue?vue&type=style&index=0&id=6f885199&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f885199"]])

export default __exports__